export default __webpack_public_path__ + "static/media/reload.2d0817e3.svg";